import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right\"><path d=\"M705.125 483.875l-337.5-300c-15-13.125-39.375-13.125-52.5 3.75-13.125 15-13.125 39.375 3.75 52.5L624.5 512 318.875 783.875c-15 13.125-16.875 37.5-3.75 52.5 7.5 7.5 16.875 13.125 28.125 13.125 9.375 0 16.875-3.75 24.375-9.375l337.5-300c7.5-7.5 13.125-16.875 13.125-28.125s-3.75-20.625-13.125-28.125z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol